import {createContext} from 'react';

const SpreadsheetsContext = createContext(null);

export default SpreadsheetsContext;
